import { OkResponseMessage, SearchResults } from "../types/backendDTOs";
import {
  RegistrationRequest,
  SingleUserDTO,
  LoginRequest,
  ArtStyle,
} from "../types/userDTOs";
import { API_URLS, config, create, fetch, getApiClient } from "./client";

export const userRegistrationCall = (data: RegistrationRequest) =>
  create<SingleUserDTO>(API_URLS().REGISTER, data);

export const userGoogleLoginCall = (credential: string) =>
  getApiClient().post<OkResponseMessage>(API_URLS().GOOGLE_LOGIN, {
    credential,
  });

export const verifyRegistrationCall = (token: string) => {
  return fetch<OkResponseMessage>(
    API_URLS().VERIFY_REGISTRATION + "?token=" + token
  );
};

export const userLoginCall = (data: LoginRequest) =>
  create<OkResponseMessage>(API_URLS().LOGIN, data);

export const fetchArtStyles = () => fetch<ArtStyle[]>(API_URLS().ART_STYLES);

export const searchBarCall = (query: string, page: number, count: number) =>
  fetch<SearchResults>(
    API_URLS().SEARCH,
    config({ query: query, page: page, count: count })
  );
